<template>
  <div class="d-flex justify-center" style="width: 100%;">
    <div class="pa-2" style="width: 100%; max-width: 1000px;">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminSectionContainer',
};
</script>
